module.exports = __webpack_public_path__ + "static/media/wheel.7e9f9c81.png";